import React, { useCallback, useEffect, useState } from 'react'
import { Row, Input } from 'antd'
import PropTypes from 'prop-types'
// Local Files
import FiltersLayout from '../component/FiltersLayout'
import TagGroup from '../../../components/TagGroup'
import HandleInputTags from '../../../helpers/HandleInputTagsHelpers'
import { AddButton } from './styled'
import isAnyField from '../helpers/isAnyField'
import { setIsOpen } from '../helpers/actionHelpers'
import Title from 'antd/lib/typography/Title'

const Language = ({ existedFilters, setExistedFilters }) => {
  const [values, setValues] = useState({
    languageValue: '',
    language: [],
    isOpen: false
  })

  // ✅ Toggle open/close
  const toggleOpen = useCallback(() => {
    setIsOpen(setValues, values)
  }, [values])

  // ✅ Add new language tag
  const handleAdd = useCallback(
    (activeInputValue, activeInput) => {
      if (!values[activeInputValue]) return

      const tags = HandleInputTags(activeInputValue, activeInput, values)
      if (tags.length > 0 && values[activeInputValue]) {
        const updatedValues = {
          ...values,
          [activeInput]: tags,
          [activeInputValue]: ''
        }
        setValues(updatedValues)

        // Update existed filters
        setExistedFilters({
          ...existedFilters,
          languages: {
            ...existedFilters.languages,
            shouldHave: updatedValues.language || []
          }
        })
      }
    },
    [values, existedFilters, setExistedFilters]
  )

  // ✅ Delete language tag
  const handleDelete = useCallback(
    (tags, activeTagsType) => {
      const updatedValues = { ...values, [activeTagsType]: tags }
      setValues(updatedValues)

      setExistedFilters({
        ...existedFilters,
        languages: {
          ...existedFilters.languages,
          shouldHave: updatedValues.language || []
        }
      })
    },
    [values, existedFilters, setExistedFilters]
  )

  // ✅ Clear all language filters
  const clearAllFilters = useCallback(() => {
    setValues({ ...values, language: [] })
    setExistedFilters({
      ...existedFilters,
      languages: {}
    })
  }, [values, existedFilters, setExistedFilters])

  // ✅ Sync from existedFilters
  useEffect(() => {
    setValues((prev) => ({
      ...prev,
      language: existedFilters?.languages?.shouldHave || []
    }))
  }, [existedFilters])

  return (
    <FiltersLayout
      title="LANGUAGE"
      setIsOpen={toggleOpen}
      isOpen={values.isOpen}
      activeFilters={isAnyField({ language: values.language })}
      clearAllFilters={clearAllFilters}
    >
      {!values.language.length && !values.isOpen && (
        <Title level={4} disabled style={{ fontSize: '14px', marginBottom: 0 }}>
          All Languages
        </Title>
      )}
      {/* Existing language tags */}
      <Row
        className="filters-tags"
        style={values.language.length ? { marginTop: '16px' } : undefined}
      >
        <TagGroup tags={values.language} onDelete={handleDelete} activeTagsType="language" />
      </Row>

      {/* Input for adding new languages */}
      {values.isOpen && (
        <Row className="search-skill-row" style={{ position: 'relative' }}>
          <Input
            name="languageValue"
            placeholder="Add Language"
            value={values.languageValue}
            onChange={(e) => setValues({ ...values, [e.target.name]: e.target.value })}
            onPressEnter={() => handleAdd('languageValue', 'language')}
          />
          <AddButton
            onClick={() => handleAdd('languageValue', 'language')}
            noBorder
            maxWidth
            absolute
            noBackground
            disabled={!values.languageValue}
          >
            Add
          </AddButton>
        </Row>
      )}
    </FiltersLayout>
  )
}

Language.propTypes = {
  existedFilters: PropTypes.object,
  setExistedFilters: PropTypes.func
}

export default Language
